import React, { Component } from "react";
import "./index.css";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

/* Components */
import DashboardSectionBase from "../../../../components/DashboardSectionBase";
import AccordionJobs from "../../../../components/AccordionJobs";
import Filter from "../../../../components/Filter";
import SelectAvailability from "../../../../components/SelectAvailability";
import SelectLocation from "../../../../components/SelectLocation";

/* Actions */
import { updateUserProfile } from "../../../../redux/actions/user";
import { setApplications, addApplication, removeApplication } from "../../../../redux/actions/application";
import { setJobs, removeJob } from "../../../../redux/actions/job";
import { setCVPreview, setAlert } from "../../../../redux/actions/misc";

/* API requests */
import { getPositions } from "../../../../api-requests/position";
import { getQualifications } from "../../../../api-requests/qualification";

const SKELETON_MIN_MS = 1000;
const SKELETON_MESSAGES = [
    "Sourcing live roles…",
    "Matching to your profile…",
    "Pulling together your shortlist…",
];

class Jobs extends Component {

    constructor(props) {
        super(props);

        this.state = {
            expandedFilter: "",
            positions: [],
            qualifications: [],
            expanded: [],
            keyword: "",
            // Keep the skeleton visible for at least SKELETON_MIN_MS so a fast
            // resolve doesn't pop-flash content in.
            showSkeleton: !!props.isFetching,
            skeletonMessageIndex: 0,
            /* Filters */
            engineers: true,
            decks: true,
            galleys: true,
            interiors: true,
            selectedPositions: "",
            selectedJobTypes: "",
            selectedQualifications: "",
            selectedCoupleFriendly: [],
            selectedYachtTypes: [],
            selectedYachtSizes: [],
            selectedYachtAges: [],
            selectedSalaryRanges: [],
        };

        this.skeletonStartedAt = props.isFetching ? Date.now() : null;
        this.skeletonTimer = null;
        this.skeletonMessageTimer = null;
    }

    componentDidMount() {
        if (this.state.showSkeleton) this.startMessageRotation();
    }

    startMessageRotation = () => {
        if (this.skeletonMessageTimer) return;
        this.skeletonMessageTimer = setInterval(() => {
            this.setState((s) => ({ skeletonMessageIndex: (s.skeletonMessageIndex + 1) % SKELETON_MESSAGES.length }));
        }, 900);
    };

    stopMessageRotation = () => {
        if (this.skeletonMessageTimer) {
            clearInterval(this.skeletonMessageTimer);
            this.skeletonMessageTimer = null;
        }
    };

    componentDidUpdate(prevProps) {
        if (!prevProps.isFetching && this.props.isFetching) {
            // Refetch started mid-life — restart the min-delay window.
            this.skeletonStartedAt = Date.now();
            if (this.skeletonTimer) clearTimeout(this.skeletonTimer);
            this.skeletonTimer = null;
            this.setState({ showSkeleton: true, skeletonMessageIndex: 0 });
            this.startMessageRotation();
        }
        if (prevProps.isFetching && !this.props.isFetching) {
            // Fetch resolved — wait the remainder of SKELETON_MIN_MS, then hide.
            const elapsed = this.skeletonStartedAt ? Date.now() - this.skeletonStartedAt : SKELETON_MIN_MS;
            const remaining = Math.max(0, SKELETON_MIN_MS - elapsed);
            if (this.skeletonTimer) clearTimeout(this.skeletonTimer);
            this.skeletonTimer = setTimeout(() => {
                this.setState({ showSkeleton: false });
                this.stopMessageRotation();
            }, remaining);
        }
    }

    componentWillUnmount() {
        if (this.skeletonTimer) clearTimeout(this.skeletonTimer);
        this.stopMessageRotation();
    }

    toggleFilter = (state) => {

        if (this.state.positions.length < 1) {
            getPositions()
                .then(result => {
                    if (result.status !== 201) return;
                    return this.setState({ positions: result.data });
                });
        } 
        
        if (this.state.qualifications.length < 1) {
            getQualifications()
                .then(result => {
                    if (result.status !== 201) return;
                    return this.setState({ qualifications: result.data });
                });
        }

        if (!state) this.setState({ keyword: "" });

        return this.setState({
            selectedPositions: "",
            selectedJobTypes: "",
            selectedQualifications: "",
            selectedCoupleFriendly: [],
            selectedYachtTypes: [],
            selectedYachtSizes: [],
            selectedYachtAges: [],
            selectedSalaryRanges: [],
        });

    }

    handleSuggestions = (state, jobs) => {

        return this.filterJobs(state, jobs);

    }

    handleFilterClick = (type, expandedFilter, input) => {

        if (!input) {
            if (type === expandedFilter) return this.setState({ expandedFilter: "" });

            return this.setState({ expandedFilter: type });
        }

        return;

    }

    handleOptionClick = (propName, item, single) => {

        if (this.state[propName].includes(item)) return this.setState({ [propName]: this.state[propName].filter(i => i !== item) });

        if (!single) return this.setState({ [propName]: [...this.state[propName], item] });

        return this.setState({ [propName]: [item] });

    }

    filterJobs = (state, jobs) => {

        if (!state.engineers) jobs = jobs.filter(job => job.position.positionType !== "Engineer");
        if (!state.decks) jobs = jobs.filter(job => job.position.positionType !== "Deck");
        if (!state.galleys) jobs = jobs.filter(job => job.position.positionType !== "Galley");
        if (!state.interiors) jobs = jobs.filter(job => job.position.positionType !== "Interior");

        if (state.selectedPositions.length > 0) {
            jobs = jobs.filter(job => {
                return job.position.name.toLowerCase().includes(state.selectedPositions.toLowerCase());
            });
        }

        if (state.selectedQualifications.length > 0) {
            jobs = jobs.filter(job => {
                return job.qualifications.toLowerCase().includes(state.selectedQualifications.toLowerCase())
            });
        }

        return jobs

    }

    searchKeyword = (e, propName) => {

        return this.setState({ [propName]: e });

    }

    render() {

        let jobs = this.handleSuggestions(this.state, this.props.jobs);

        return(
            <>
                {!this.props.admin &&
                    <DashboardSectionBase title="Match preferences" subtitle="Tell us when and where you can work - we'll surface jobs that fit.">
                        <div className="jobs-search-prefs">
                            <div className="jobs-search-prefs-item">
                                <SelectAvailability />
                            </div>
                            <div className="jobs-search-prefs-item">
                                <SelectLocation />
                            </div>
                        </div>
                    </DashboardSectionBase>
                }
            <DashboardSectionBase title={this.props.title}>
                {!this.state.showSkeleton &&
                    <div className="jobs-description-container margin-top-20px">
                        {this.props.description}
                    </div>
                }
                {this.props.filter &&
                    <div className="jobs-filters-container">
                        <div className="jobs-filters-section-container" style={{ paddingRight: 20 }}>
                            <div className="margin-top-20px">
                                <Filter label={"Search Position"} type={"position"} handleFilterClick={this.handleFilterClick} propName={"selectedPositions"} input={true} keyword={this.state.selectedPositions} changeText={this.searchKeyword} />
                            </div>
                        </div>
                        <div className="jobs-filters-section-container">
                            <div className="margin-top-20px">
                                <Filter label={"Search Qualification"} type={"qualifications"} handleFilterClick={this.handleFilterClick} propName={"selectedQualifications"} input={true} keyword={this.state.selectedQualifications} changeText={this.searchKeyword} />
                            </div>
                        </div>
                    </div>
                }
                {this.state.showSkeleton &&
                    <div className="jobs-skeletons margin-top-20px" aria-hidden="true">
                        <div className="jobs-skeleton-hero" role="status" aria-live="polite">
                            <span className="jobs-skeleton-hero-pulse" aria-hidden="true">
                                <span className="jobs-skeleton-hero-pulse-dot" />
                                <span className="jobs-skeleton-hero-pulse-ring" />
                            </span>
                            <span className="jobs-skeleton-hero-text" key={this.state.skeletonMessageIndex}>
                                {SKELETON_MESSAGES[this.state.skeletonMessageIndex]}
                            </span>
                        </div>
                        <div className="jobs-skeleton-scan" aria-hidden="true" />
                        {[0, 1, 2, 3, 4].map(i => (
                            <div className="jobs-skeleton-card" key={i} style={{ animationDelay: `${i * 110}ms` }}>
                                <span className="jobs-skeleton-card-accent" aria-hidden="true" />
                                <div className="jobs-skeleton-row jobs-skeleton-row--header">
                                    <div className="jobs-skeleton-line jobs-skeleton-line--title" />
                                    <div className="jobs-skeleton-pill" />
                                </div>
                                <div className="jobs-skeleton-line jobs-skeleton-line--salary" />
                                <div className="jobs-skeleton-row">
                                    <div className="jobs-skeleton-line jobs-skeleton-line--meta-a" />
                                    <div className="jobs-skeleton-dot" />
                                    <div className="jobs-skeleton-chip" />
                                </div>
                                <div className="jobs-skeleton-line jobs-skeleton-line--desc-1" />
                                <div className="jobs-skeleton-line jobs-skeleton-line--desc-2" />
                                <div className="jobs-skeleton-row jobs-skeleton-row--footer">
                                    <div className="jobs-skeleton-line jobs-skeleton-line--ts" />
                                    <div className="jobs-skeleton-line jobs-skeleton-line--link" />
                                </div>
                            </div>
                        ))}
                    </div>
                }
                {!this.state.showSkeleton && jobs.length > 0 &&
                    <div className="margin-top-20px">
                        <AccordionJobs admin={this.props.admin} applications={this.props.applicationState.applications} setApplications={this.props.setApplications} setJobs={this.props.setJobs} setAlert={this.props.setAlert} setCVPreview={this.props.setCVPreview} apply={this.props.addApplication} withdraw={this.props.removeApplication} type={this.props.type} profile={this.props.user.data.profile} jobs={jobs} expanded={this.state.expanded} handleRow={(result) => this.setState({ expanded: result })} updateUserProfile={this.props.updateUserProfile} removeJob={this.props.removeJob} />
                    </div>
                }
            </DashboardSectionBase>
            </>
        );

    }  

}

const mapStateToProps = (state) => {
    return {
        user: state.user,
        applicationState: state.application,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        ...bindActionCreators({ setApplications, setJobs, setCVPreview, updateUserProfile, removeJob, addApplication, removeApplication, setAlert }, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Jobs);